<template>
   <el-card :class="`box-card user-verification-card mt-3 ${status} ${nivel}`">
<!--      <div slot="header">
         <strong>PERFIL {{status}}</strong>
      </div>-->
      <b-row align-content="center" align-h="center" align-v="center">
         <b-col cols="12" class="text-center">
            <el-avatar fit="cover" :size="110" :src="user.avatarUrl || NoAvatar"></el-avatar>
            <div v-if="nivel" class="badge-nivel">
               <img :src="nivel === 'ouro' ? BadgeNivelOuro : nivel === 'prata' ? BadgeNivelPrata : nivel === 'bronze' ? BadgeNivelBronze : ''" alt="Brazão">
            </div>
            <div v-else style="margin: -10px 0 10px 0;">
               <i class="el-icon-loading"></i>
            </div>
            <h5 class="text-dark">{{user.firstName}} {{user.lastName}}</h5>
               <p v-if="nivel" class="nivel">Nível {{nivel}}</p>
               <p v-else class="nivel text-muted">Carregando nível...</p>
            <hr>
         </b-col>

         <b-col cols="9">
            <h6 v-if="userExternalData" class="text-dark text-center">Ciclista verificou:</h6>
            <h6 v-else class="text-dark text-center">Você já verificou:</h6>
            <ul class="list-unstyled pl-3">
               <li v-for="(item, index) in verificationItens" :key="index" :class="`${item.checked ? 'checked' : 'no-checked'}`">
                  <span v-if="nivel" >
                     <img :src="item.checked ? CheckImg : NoCheckImg" alt="">
                  </span>
                  <span v-else style="margin-right: 7.5px">
                     <i class="el-icon-loading"></i>
                  </span>
                  {{item.name}}
               </li>
            </ul>
         </b-col>

         <div class="px-3 text-center" v-if="showCTA && nivel !== 'ouro' ">
            <hr>
            <p class="font-strong text-muted">Torne-se um usuário <span style="color: #BD992C">Ouro</span>, e aumente a sua reputação na plataforma Pedale.</p>

            <el-button
               class="font-weight-bold text-uppercase mb-3 mx-auto"
               size="mini"
               type="primary"
               :round="true"
               @click="$router.push({name: 'verificacoes'})"
            >
               Verifique seu perfil agora
            </el-button>
         </div>

         <div class="px-3 text-center" v-if="showCTA && nivel === 'ouro' ">
            <hr>
            <p class="font-strong text-muted">Parabéns, você é um usuário com reputação <span style="color: #BD992C">Ouro</span> na plataforma Pedale.</p>
         </div>

      </b-row>
   </el-card>
</template>

<script>
import CheckImg from "@/assets/img/check.svg"
import NoCheckImg from "@/assets/img/no-check.svg"
import BadgeNivelOuro from "@/assets/img/nivel-ouro.svg"
import BadgeNivelPrata from "@/assets/img/nivel-prata.svg"
import BadgeNivelBronze from "@/assets/img/nivel-bronze.svg"
import NoAvatar from "@/assets/img/no-avatar-2.jpg"

export default {
   name: 'UserVerificationCard',
   props: {
      userExternalData: {
         type: Object,
      },
      showCTA: {
         type: Boolean,
         default: false
      }
   },
   data() {
      return {
         CheckImg,
         NoCheckImg,
         BadgeNivelOuro,
         BadgeNivelPrata,
         BadgeNivelBronze,
         NoAvatar,
         nivel: '',
         status: '',
         userData: {
            _id: '',
            firstName: '',
            lastName: '',
            email: '',
            additionalInformation: {
               verifiedPhone: null
            },
            address: {},
            social: [],
            documents: [],
         },
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         user: {
            firstName: '',
            lastName: '',
            avatarUrl: ''
         },
         verificationItens: [
            {
               name: 'Foto Perfil',
               checked: null
            },
            {
               name: 'Facebook',
               checked: null,
            },
            {
               name: 'Instagram',
               checked: null
            },
            {
               name: 'Strava',
               checked: null
            },
            {
               name: 'Telefone',
               checked: null
            },
            {
               name: 'Documento pessoal',
               checked: null
            },
            {
               name: 'Endereço',
               checked: null

            }
         ],
         scores: {
            avatar: null,
            social: null,
            phone: null,
            personalDoc: null,
            addressDoc: null
         }
      }
   },
   beforeDestroy() {
      this.userData = {}
      this.nivel = ''
      this.user = {}
      this.scores = {}
   },
   mounted() {

      // aprovado, em análise, reprovado
      this.status = 'aprovado'

      if (!this.userExternalData) {
         setTimeout(() => {
            if (this.userStoreData) {
               this.userData = this.userStoreData
               this.userScore(this.userData)
            }
         }, 1000)
      }
   },
   methods: {
      userScore(userData) {
         const { social, additionalInformation, documents, avatar, firstName, lastName } = userData


         this.user.avatarUrl = this.createUrlAvatar(avatar)
         this.user.firstName = firstName
         this.user.lastName = lastName

         this.scores.avatar = userData.avatar ? 5 : 0

         // Verifica se ao menos uma rede social foi preenchida. Caso sim, retorna 30.
         this.scores.social = social.map(s => s.name === 'facebook' && s.url ||
            s.name === 'instagram' && s.url ||
            s.name === 'strava' && s.url ? true : false
         ).find(f => f === true) ? 5 : 0


         // Verifica se o telefone está verificado. Caso sim, retorn 30
         this.scores.phone = additionalInformation.verifiedPhone ? 30 : 0


         // Verifica se o Doc Pessoal foi enviado e está verificado, caso sim, retorna 30.
         // Caso tenha sido enviado somente a frente, também é possível.
         documents
            .filter(d => d.status === 2)
            .map(d => {

               // Verifica se um doc pessoal está aprovado
               if (d.nameSpace === "docUser/rg/frente" ||
                  d.nameSpace === "docUser/cnh/frente" ||
                  d.nameSpace === "docUser/rg/verso" ||
                  d.nameSpace === "docUser/cnh/verso"
               ) {
                  this.scores.personalDoc = 30
               }

               // Verifica se o comprovante de endereço foi enviado
               if (d.nameSpace === "docUser/água" ||
                  d.nameSpace === "docUser/luz" ||
                  d.nameSpace === "docUser/telefone" ||
                  d.nameSpace === "docUser/outros"
               ) {
                  this.scores.addressDoc = 30
               }
         })

         // Verifica se o Comprovante de endereço foi enviado e está verificado, caso sim, retorna 30.

         // Lida com os valores do score
         this.handleNivel(userData)
      },

      handleNivel(userData) {

         // Se for até 60, é broze. Se for até 80 é prata. Se for 100 é ouro.
         const scoreSum = this.scores.social + this.scores.phone + this.scores.personalDoc + this.scores.addressDoc
         if (scoreSum < 35)
            this.nivel = 'bronze'
         if (scoreSum >= 35 && scoreSum < 100)
            this.nivel = 'prata'
         if (scoreSum > 90)
            this.nivel = 'ouro'


         // Verifica se tem foto do perfil
         this.verificationItens[0].checked = userData.avatar && userData.avatar.destination || false

         // Verifica se o facebook está verificado
         this.verificationItens[1].checked = userData.social.find( f => f.name === 'facebook' && f.url)

         // Verifica se o instagram está verificado
         this.verificationItens[2].checked = userData.social.find( f => f.name === 'instagram' && f.url)

         // Verifica se o strava está verificado
         this.verificationItens[3].checked = userData.social.find( f => f.name === 'strava' && f.url)

         // Verifica se o telefone está verificado
         this.verificationItens[4].checked = userData.additionalInformation.verifiedPhone || false

         // Verifica se o Documento pessoal está verificado
         this.verificationItens[5].checked = userData.documents
            .filter(f => f.status === 2)
            .find(d => d.nameSpace === "docUser/rg/frente" ||
                     d.nameSpace === "docUser/cnh/frente" ||
                     d.nameSpace === "docUser/rg/verso" ||
                     d.nameSpace === "docUser/cnh/verso"
            )

         // Verifica se o Comprovante de endereço está verificado
         this.verificationItens[6].checked = userData.documents
            .filter(f => f.status === 2)
            .find(d => d.nameSpace === "docUser/água" ||
               d.nameSpace === "docUser/luz" ||
               d.nameSpace === "docUser/telefone" ||
               d.nameSpace === "docUser/outros"
            )

      },
      createUrlAvatar(url) {
         if (url) {
            let uri;
            const imgDir = url.destination;
            if (url.filename) {
               uri = `${this.baseUrl}/${imgDir}/${url.filename}`
               return uri;
            }
         }
      }
   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      userStoreData() {
         return this.$store.state.user.data
      }
   },
   watch: {
      userExternalData(n) {
         this.userScore(n)
      },
      userStoreData(n) {
         this.userScore(n)
      },
   }
}
</script>

<style lang="scss" scoped>

</style>
